import * as d3 from 'd3'
import _ from 'lodash'

export const getGraphNodeTitle = node => {
  if (node.ax)
    return getMatrixAxis(node, node.ax)
  return node.name
}

export const getMatrixAxis = (node, name) => {
  if (name in node) {
    if (typeof (node[name]) == 'number')
      return (node[name] + 1).toString()
    else
      return node[name].toString()
  }
  if (node[name]) {
    return node[name]
  }
  return ''
}

export const getMatrixAxisLabel = (node, name) => {
  if (node.ax && node.ax !== name) {
    if (name !== 'division' || node.ax !== 'department')
      return ''
  }
  return getMatrixAxis(node, name)
}

export const getFontSize = (defaultFontSize, nodes, d) => {
  return Math.min(48, defaultFontSize * Math.max(Math.min(getSize(nodes[d.x]), getSize(nodes[d.y])) / 3, 1));
}

export const getMatrixAxisKey = (node, ax) => {
  if (ax === 'department')
    return getMatrixAxis(node, 'division') + '@' + getMatrixAxis(node, ax)
  return getMatrixAxis(node, ax)
}

export const getDepartmentNames = (nodes, groupMapping) => {
  nodes.forEach(node => node.groupName = groupMapping[node.group])

  // let grouped = Object.values(_.groupBy(nodes, node => node.group))
  // grouped.forEach(groupedDepartments => {
  //   let departmentNames = _.countBy(groupedDepartments.map(node => node.department))
  //   let maxOccurences = Math.max(...Object.values(departmentNames))
  //   let maxDepartments = Object.keys(_.pickBy(departmentNames, (value, key) => value === maxOccurences))
  //   if (maxDepartments.length === 1) {
  //     groupedDepartments.rule1Name = maxDepartments[0]
  //     groupedDepartments.maxOccurences = maxOccurences
  //   }
  // })

  // Object.values(_.groupBy(grouped, group => group.rule1Name)).forEach(group => {
  //   group.sort((a, b) => {
  //     if (a.maxOccurences !== b.maxOccurences)
  //       return b.maxOccurences - a.maxOccurences
  //     else
  //       return a.length - b.length
  //   })
  //   group.forEach((g, i) => {
  //     if (i > 0)
  //       g.rule1Name = null
  //   })
  // })

  // grouped.forEach(groupedDepartments => {
  //   if (!groupedDepartments.rule1Name) {
  //     let namePositions = _.concat(...groupedDepartments.map(node =>
  //       node.department.split(' ').filter(word => word).map((word, i) => [word, i]))
  //     )
  //     let positions = Object.values(_.groupBy(namePositions, namePositions => namePositions[0]))
  //     positions = positions.filter(position => position.length > 1)
  //     if (positions.length) {
  //       positions = positions.map(position => [position[0][0], _.mean(position.map(p => p[1]))])
  //       positions.sort((a, b) => a[1] - b[1])
  //       positions = positions.map(p => p[0])
  //       let rule2Name = positions.join(' ')
  //       if (grouped.map(g => g.rule1Name).indexOf(rule2Name) === -1) {
  //         groupedDepartments.rule1Name = rule2Name
  //       }
  //     }
  //   }
  // })

  // let mixedIdx = 1
  // grouped.forEach(groupedDepartments => {
  //   if (!groupedDepartments.rule1Name) {
  //     groupedDepartments.rule1Name = 'Mixed ' + mixedIdx
  //     mixedIdx++
  //   }
  //   groupedDepartments.forEach(node => {
  //     node.groupName = groupedDepartments.rule1Name
  //   })
  // })

  // if (grouped.length !== [...new Set(grouped.map(g => g.rule1Name))].length) {
  //   console.log('assign suggested name has duplicates')
  // }
}

let colors = [
  'ff0029', '377eb8', '66a61e', '984ea3', '00d2d5', 'ff7f00', 'af8d00',
  '7f80cd', 'c42e60', 'a65628',
  'fb8072', '80b1d3', 'fdb462', 'bc80bd',
  'cf8c00', '1b9e77', 'd95f02', 'e7298a', 'e6ab02', 'a6761d', '0097ff',
  '00d067', '000000', '252525', '525252', '737373', '969696',
  'f43600', '4ba93b', '5779bb', '927acc', '97ee3f', 'bf3947', '9f5b00',
  'f48758', '8caed6', 'f2b94f', 'e43872', 'd9b100', '9d7a00',
  '698cff', '00d27e', 'd06800', '009f82', 'c49200',
  'c27eb6', '8cd2ce', 'c4b8d9', 'f883b0', 'a49100', 'f48800',
  '27d0df', 'a04a9b'
]


export const assignParticipants = (data, assignLinks = true) => {
  let { group_mapping } = data
  let { nodes, links } = data.result
  let participants = data.participants.data
  let valid = true

  nodes.sort((a, b) => a.group - b.group);

  nodes.forEach(node => {
    participants.forEach(participant => {
      if (node.id === participant.id) {
        node.name = ((participant.sfirstname || '') + ' ' + (participant.slastname || '')).trim()
        node.department = participant.sdepartment || ''
        node.title = participant.stitle || ''
        node.division = participant.sdivision || ''
        node.location = participant.smailingaddresscity || ''
      }
    })
    if (!node.name) {
      valid = false
    }
  })

  if (assignLinks && valid) {
    let groupedNodes = _.keyBy(nodes, node => node.id)
    links.forEach(link => {
      link.sourceId = link.source
      link.source = groupedNodes[link.source]
      link.targetId = link.target
      link.target = groupedNodes[link.target]
    })
    data.result.links = links.filter(link => link.source && link.target)

    getDepartmentNames(nodes, group_mapping)

    if (data.is_base && group_mapping) {
      nodes.forEach(node => node.department = node.groupName)
    }

    let groupNames = {}
    nodes.forEach(node => {
      groupNames[node.group] = node.groupName
    })
  }

  return valid
}

export const strokeWidth = d => {
  let count = d.count
  if (d.edited && !d.count) count = 1
  return d.border || d.edited ? d.count ? Math.sqrt(count) : 1 : 1
}


export const toHex = idx => {
  return colors[idx]
}

export const getRoot = (node) => {
  if (!node.parent)
    return node
  return getRoot(node.parent)
}

export const getSize = node => {
  return [...(node.childNodes || []), node].filter(n => n.filtered).length
}
export const setChild = (parent, child) => {
  (parent.childNodes = parent.childNodes || []).push(child)
  child.parent = parent
}

export const removeAllChild = node => {
  if (node.ax) {
    node.ax = null
    node.byzoom = false
    node.selection = false
    if (node.childNodes) {
      node.childNodes.forEach(n => {
        n.parent = null
        n.selection = false
      })
      node.childNodes = null
    }
  }
}

export const expandNode = node => {
  removeAllChild(node)
}

export const collapseNode = (node, ax, totalNodes) => {
  if (ax && !node.parent && node.ax !== ax) {
    node.ax = ax
    totalNodes.forEach(n => {
      if (node !== n && !n.parent && getMatrixAxisKey(n, ax) === getMatrixAxisKey(node, ax)) {
        setChild(node, n)
      }
    })
    return true
  } else {
    return false
  }
}

export const collapseOrExpandNode = (clickedNode, ax, totalNodes) => {
  if (ax && clickedNode.ax === ax) {
    expandNode(clickedNode)
    return true
  } else {
    // collapseNode(clickedNode, ax, totalNodes)
    return false
  }
}

export const removeAllParents = nodes => {
  nodes.forEach(node => {
    removeAllChild(node)
  })
}

export const collapseAll = (ax, totalNodes) => {
  let groupby = totalNodes.reduce((v, x) => {

    if (!x.parent && x.filtered)
      (v[getMatrixAxisKey(x, ax)] = v[getMatrixAxisKey(x, ax)] || []).push(x)
    return v
  }, {})

  for (let value of Object.values(groupby)) {
    let headNode = value[0]
    headNode.rowselection = false
    headNode.colselection = false
    if (value.length > 1) {
      headNode.ax = ax
      value.forEach(v => {
        if (v !== headNode) setChild(headNode, v)
      })
    } else {
      headNode.ax = null;
    }
  }
}

export const makeClone = (data) => {
  let nodes = data.nodes.map(node => ({
    id: node.id,
    group: node.group,
    name: node.name,
    department: node.department,
    title: node.title,
    division: node.division,
    groupName: node.groupName
  }))
  let links = data.links.map(link => ({
    sourceId: link.sourceId,
    targetId: link.targetId,
    value: link.value,
    reported_by: link.reported_by,
    frequency: link.frequency,
    permanence: link.permanence,
    value_new: link.value_new,
    duration: link.duration,
    relationship: link.relationship
  }))
  let groupedNodes = _.keyBy(nodes, node => node.id)
  nodes.forEach(node => {
    if (node.parent)
      node.parent = groupedNodes[node.parent.id]
  })
  links.forEach(link => {
    link.source = groupedNodes[link.sourceId]
    link.target = groupedNodes[link.targetId]
  })
  return {
    nodes: nodes,
    links: links
  }
}

const hasActivity = (activities, filter) =>
  !filter.length ||
  filter.filter(
    activity => activities.indexOf(activity) > -1
  ).length > 0

const hasPermanence = (permanence, filter) => !filter.length || filter.indexOf(permanence) > -1

export const filterGraphData = (graphData, {
  filterDepartments, filterCurrentDepartments, filterActivities, filterDivisions, filterLocations, filterPermanence, filterTitles
}, collapseBy) => {
  let filterDepartmentsValues = (filterDepartments || []).map(
    group => group.value
  )
  let filterCurrentDepartmentsValues = (filterCurrentDepartments || []).map(
    group => group.value
  )

  let filterActivitiesValues = (filterActivities || []).map(
    activity => String(activity.value)
  )
  let filterDivisionValues = (filterDivisions || []).map(
    division => division.value
  )
  let filterLocationValues = (filterLocations || []).map(
    location => location.value
  )

  let filterTitleValues = (filterTitles || []).map(
    location => location.value
  )

  let filterPermanenceValues = (filterPermanence || []).map(
    permanence => permanence.value
  )

  const matrixMap = {};

  graphData.links.forEach(link => {
    if (!matrixMap[link.sourceId]) {
      matrixMap[link.sourceId] = {}
    }
    matrixMap[link.sourceId][link.targetId] = 1;
    if (
      matrixMap[link.targetId]
      && matrixMap[link.targetId][link.sourceId] === 1
    ) {
      link.bidirect = true;
    }
  })

  graphData.nodes.forEach(node => {
    node.count = 0;
    node.incoming = 0;
    node.incomingLinks = [];
    node.outgoing = 0;
    node.outgoingLinks = [];
    node.both = 0;
    node.sourceRaw = [];
    node.targetRaw = [];
    node.uid = getGraphNodeTitle(node);
    node.filtered = (
      filterDepartmentsValues.length === 0
      || filterDepartmentsValues.indexOf(node.group) > -1
    ) && (
        filterDivisionValues.length === 0
        || filterDivisionValues.indexOf(node.division) > -1
      ) && (
        filterLocationValues.length === 0
        || filterLocationValues.indexOf(node.location) > -1
      ) && (
        filterCurrentDepartmentsValues.length === 0
        || filterCurrentDepartmentsValues.indexOf(node.department) > -1
      ) && (
        filterTitleValues.length === 0
        || filterTitleValues.indexOf(node.title) > -1
      );
  });

  let visibleNodes = graphData.nodes.filter(node => (node.filtered || (node.childNodes || []).some(node => node.filtered)) && !node.parent)
  let filteredNodes = graphData.nodes.filter(node => node.filtered)


  let matrix = []

  visibleNodes.forEach((node, i) => {
    node.index = i
    matrix[i] = visibleNodes.map((node1, j) => {
      return {
        x: j,
        y: i,
        z: 0,
        link: null,
        border: node.group === node1.group ? 1 : 0,
        relationship: new Set(),
        count: 0,
        frequency: 0,
        permanence: 0,
        value_new: 0,
        duration: 0,
        edited: false
      }
    })
  })

  let n = visibleNodes.length

  graphData.links.forEach(link => {
    if (!link.source.filtered || !link.target.filtered) {
      return
    }
    let sourceNode = getRoot(link.source)
    let targetNode = getRoot(link.target)
    let source = sourceNode.index
    let target = targetNode.index
    if (source >= n || target >= n) {
      source = 0
    }

    let matrixCell = matrix[target][source];

    matrixCell.link = link
    if (!matrixCell.links) {
      matrixCell.links = [{ reportedBy: link.reported_by }];
    } else {
      matrixCell.links.push({ reportedBy: link.reported_by });
    }
    matrixCell.edited |= link.edited;

    if (
      hasActivity(link.relationship, filterActivitiesValues) &&
      hasPermanence(link.permanence, filterPermanenceValues)
    ) {
      matrixCell.z += link.value;
      matrixCell.frequency += link.frequency;
      matrixCell.permanence += link.permanence;
      matrixCell.value_new += link.value_new;
      matrixCell.duration += link.duration;
      matrixCell.count++;

      let relationship = matrixCell.relationship;
      link.relationship.forEach(relationship.add, relationship);
      sourceNode.count += link.value;
      sourceNode.outgoing += 1;
      sourceNode.outgoingLinks.push({ reportedBy: link.reported_by });
      targetNode.count += link.value;
      targetNode.incoming += 1;
      targetNode.incomingLinks.push({ reportedBy: link.reported_by });
      if (link.bidirect) {
        sourceNode.both++;
        targetNode.both++;
      }
      sourceNode.sourceRaw.push(link);
      targetNode.targetRaw.push(link);
    }
  })

  let links = []

  let minPercent = 100
  let maxPercent = 0

  for (let i = 0; i < n; i++) {
    for (let j = 0; j < n; j++) {
      if (matrix[i][j].count) {
        links.push({
          sourceId: visibleNodes[i].id,
          targetId: visibleNodes[j].id,
          source: visibleNodes[i],
          target: visibleNodes[j],
          permanence: matrix[i][j].count ? matrix[i][j].permanence / matrix[i][j].count : 0,
          frequency: matrix[i][j].count ? matrix[i][j].frequency / matrix[i][j].count : 0,
          value_new: matrix[i][j].count ? matrix[i][j].value_new / matrix[i][j].count : 0,
          duration: matrix[i][j].count ? matrix[i][j].duration / matrix[i][j].count : 0,
          value: matrix[i][j].count ? matrix[i][j].z / matrix[i][j].count : 0,
          count: matrix[i][j].count,
          relationship: matrix[i][j].relationship,
          strength: visibleNodes[i].group === visibleNodes[j].group ? 20 : 100
        })
      }
      let nSource = getSize(visibleNodes[i])
      let nTarget = getSize(visibleNodes[j])
      if (nSource > 1 || nTarget > 1) {
        if (i === j) nTarget -= 1
        matrix[i][j].percent = matrix[i][j].count * 100 / (nSource * nTarget)
        if (i !== j) {
          minPercent = Math.min(matrix[i][j].percent, minPercent)
          maxPercent = Math.max(matrix[i][j].percent, maxPercent)
        }
      }
    }
  }


  return {
    nodes: visibleNodes,
    links,
    matrix,
    filteredNodes,
    minPercent,
    maxPercent
  }
}

export const getGroupColors = n => {
  return d3.scaleOrdinal().range(colors)
}

export const groupColorArray = colors;

export const deepClone = (obj) => {
  if (!obj || typeof obj !== 'object') {
    return obj
  }
  let newObj = {}
  if (Array.isArray(obj)) {
    newObj = obj.map(item => deepClone(item))
  } else {
    Object.keys(obj).forEach((key) => {
      return newObj[key] = deepClone(obj[key])
    })
  }
  return newObj
}


export const parseJson = str => {
  try {
    return JSON.parse(str)
  } catch (e) {
    return null
  }
}

export const parseImportance = (value, threshold) => {
  if (value >= threshold.critical) {
    return 'Critical'
  } else if (value >= threshold.medium) {
    return 'Medium'
  } else {
    return 'Low'
  }
}

export const parseEstimatedCoordinationFTE = (value) => {
  if (value <= 7) {
    return 'Less than 1 day per month'
  } else if (value < 40) {
    return 'Up to 1 week per month'
  } else if (value < 80) {
    return 'Up to 2 weeks per month'
  } else if (value < 120) {
    return 'Up to 3 weeks per month'
  } else if (value < 160) {
    return 'Up to 4 weeks per month'
  } else {
    return 'Every day'
  }
}

export const parseImportanceInt = (value, threshold) => {
  if (value === 0) {
    return 0
  } else if (value >= threshold.critical) {
    return 3
  } else if (value >= threshold.medium) {
    return 2
  } else {
    return 1
  }
}

export const toImportance = (value, threshold) => {
  if (value === 'None') {
    return 0
  } else if (value === 'Critical')
    return threshold.critical + 0.5
  else if (value === 'Medium')
    return (threshold.medium + threshold.critical) / 2
  else
    return (threshold.low + threshold.medium) / 2
}

export const toServerData = data => {
  if (!data)
    return null
  return {
    ...data,
    nodes: data.nodes.map(node => ({
      id: node.id,
      group: node.group
    })),
    links: data.links && data.links.filter(
      link => link.value && link.relationship && link.relationship.length
    ).map(link => ({
      source: link.sourceId,
      target: link.targetId,
      relationship: link.relationship,
      value: link.value,
      frequency: link.frequency,
      permanence: link.permanence,
      duration: link.duration,
      value_new: link.value_new,
      reported_by: link.reported_by || 'admin'
    }))
  }
}

export const checkSurveyData = survey => {
  let error = {}
  if (!survey || !survey.title || survey.title.trim() === '') {
    error.title = 'Survey title can\'t be empty'
  }
  if (!survey || !survey.activities || !survey.activities.length) {
    error.activities = 'There should be at least one activity.'
  }
  if (!survey || !survey.participants || !survey.participants.length) {
    error.participants = 'There should be at least one participant.'
  }
  if (survey && survey.activitiesError) {
    error.activities = 'There are some invalid activity inputs in the table'
  }
  if (survey && survey.participantsError) {
    error.participants = 'There are some invalid participant inputs in the table'
  }
  return error
}

export const reorder = (analyses, ids) => {
  if (ids instanceof Array) {
    analyses.sort((x, y) => ids.indexOf(x.id) - ids.indexOf(y.id))
  } else {
    analyses.sort((x, y) => y.created.localeCompare(x.created))
  }
}

export async function waitForFontLoad(
  font,
  timeout = 1000,
  interval = 10
) {
  return new Promise((resolve, reject) => {
      // repeatedly poll check
      const poller = setInterval(async () => {
          try {
            await document.fonts.load(font);
            if (document.fonts.check(font)) {
                clearInterval(poller);
                resolve(true);
            }
          } catch (err) {
          }
      }, interval);
      setTimeout(() => clearInterval(poller), timeout);
  });
}

export function loadFont(cb) {
	const request = new XMLHttpRequest();
	request.open("get", "https://fonts.googleapis.com/css?family=Open+Sans");
	request.responseType = "text";
  request.send();
	request.onloadend = () => {
		
		//(2)find all font urls.
		let css = request.response;
		const fontURLs = css.match(/https?:\/\/[^ \)]+/g);
		let loaded = 0;
		fontURLs.forEach(url => {
			
			//(3)get each font binary.
			const request = new XMLHttpRequest();
			request.open("get", url);
			request.responseType = "blob";
			request.onloadend = () => {
				
				//(4)conver font blob to binary string.
				const reader = new FileReader();
				reader.onloadend = () => {
					//console.log(css)
					//(5)replace font url by binary string.
					css = css.replace(new RegExp(url), reader.result);
					loaded++;
					//check all fonts are replaced.
					if(loaded === fontURLs.length){
            cb(css);
					}
				};
				reader.readAsDataURL(request.response);
			};
			request.send();
		});
	};
}


export function getResultData(data, participants) {
  let group_mapping = data.assigned.map(group => group.group_name)
  let nodes = _.flatten(data.assigned.map((group, key) => group.items.map(item => ({ ...item, id: item.id, group: Number(key), groupName: group_mapping[Number(key)] }))))
  const allAssigned = nodes.length === participants.length
  if (data.unassigned.length) {
    group_mapping = [...group_mapping, 'ungrouped']
    const unassigned_nodes = data.unassigned.map(item => ({...item, group: group_mapping.length - 1, groupName: '' }))
    nodes = [...nodes, ...unassigned_nodes]
  }

  const valid = nodes.length === participants.length

  return {
    valid,
    group_mapping,
    nodes,
    allAssigned
  }
}


export function cloneData(data) {
  return JSON.parse(JSON.stringify(data));
}